import React from 'react'
import cn from 'classnames'
import whatInput from 'what-input'
import TickBox from './Tickbox'

type Props = {
  selected?: boolean
  type: string
  id: string
  value: number | string
  valueText?: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onFocus?: () => void
  onBlur?: () => void
  onKeyDown?: () => void
  error?: string
  index?: number
  dataUid?: string
  label?: React.ReactNode
  placeholder?: string
  name: string
}

const InputField = ({
  selected,
  type,
  value,
  valueText,
  onChange,
  onFocus,
  onBlur,
  onKeyDown,
  index,
  placeholder,
  label,
  dataUid,
  error,
  name,
  id,
}: Props) => {
  return type === 'radio' ? (
    <label
      className={cn(
        'relative w-1/2 rounded-8 border-1 bg-BgMain px-20 pb-16 pt-[18px] text-14 font-demibold text-TypeSub transition type-14-demibold',
        index === 0 ? 'mr-[10px]' : 'ml-[10px]',
        selected ? 'border-LSBrand text-LSBrand' : 'border-none',
        {
          'focus-within:bg-green-lightest': whatInput.ask() === 'keyboard',
          'hover:border-grey-lighter': !selected,
        },
      )}
    >
      <div className={cn('flex items-center', selected && 'text-LSBrand')}>
        <input
          data-uid={dataUid}
          className="absolute opacity-0"
          type={type}
          onChange={onChange}
          value={value}
          name={name}
        />
        {type === 'radio' && <TickBox selected={selected} />}
        {valueText}
      </div>
    </label>
  ) : (
    <div className="mb-11 text-left">
      <label htmlFor={id} className="text-14 font-demibold">
        {label ? label : null}
      </label>
      <input
        id={id}
        data-jump-target
        data-uid={dataUid}
        className={
          'w-full rounded-8 bg-BgMain px-20 pb-16 pt-[18px] text-TypeSub transition type-14-demibold'
        }
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        type={type}
        placeholder={placeholder}
        value={value !== null ? value : ''}
      />
      {error ? (
        <div className="text-14 font-demibold text-red">{error}</div>
      ) : null}
    </div>
  )
}

export default InputField
